import { createSlice } from '@reduxjs/toolkit';

import { RESET_COUNTER_NUMBER } from '../../constants/uploaderTipDialog';

const slice = createSlice({
  name: 'clientUI',
  initialState: {
    uploaderTipDialogCounter: 0,
    uploaderTipDialogDoNotShowAgain: false,
    autoUploaderTipDialogDoNotShowAgain: false,
    uploaderBackDialogDoNotShowAgain: false,
    cameraIOSTipDialogDoNotShowAgain: false,
    isFormBlocked: false,
    reportStatus: null,
  },
  reducers: {
    updateUploaderTipDialogCounter: (state) => {
      const { uploaderTipDialogCounter } = state;
      if (uploaderTipDialogCounter === RESET_COUNTER_NUMBER) {
        state.uploaderTipDialogCounter = 0;
      } else {
        state.uploaderTipDialogCounter += 1;
      }
    },
    updateUploaderTipDialogDoNotShowAgain: (state, action) => {
      state.uploaderTipDialogDoNotShowAgain = action.payload;
    },
    updateAutoUploaderTipDialogDoNotShowAgain: (state, action) => {
      state.autoUploaderTipDialogDoNotShowAgain = action.payload;
    },
    updateUploaderBackDialogDoNotShowAgain: (state, action) => {
      state.uploaderBackDialogDoNotShowAgain = action.payload;
    },
    updateCameraIOSTipDialogDoNotShowAgain: (state, action) => {
      state.cameraIOSTipDialogDoNotShowAgain = action.payload;
    },
    blockForm: (state, action) => {
      state.isFormBlocked = action.payload;
    },
    clearReportStatus: (state) => {
      state.reportStatus = null;
    },
    offlineReportStatus: (state) => {
      state.reportStatus = 'offline';
    },
    progressReportStatus: (state) => {
      state.reportStatus = 'in-progress';
    },
  },
  extraReducers: {
    'visit/postAttachments/commit': (state) => {
      state.reportStatus = 'success';
    },
    'visit/postAttachments/rollback': (state) => {
      state.reportStatus = 'fail';
    },
  },
});

export const {
  updateUploaderTipDialogCounter,
  updateUploaderTipDialogDoNotShowAgain,
  updateAutoUploaderTipDialogDoNotShowAgain,
  updateUploaderBackDialogDoNotShowAgain,
  updateCameraIOSTipDialogDoNotShowAgain,
  blockForm,
  clearReportStatus,
  offlineReportStatus,
  progressReportStatus,
} = slice.actions;

export default slice.reducer;
